/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_Price_SuffixInputs */

const et_plan_website_price_suffix = /** @type {(inputs: Plan_Website_Price_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ühekordne tasu`)
};

const en_plan_website_price_suffix = /** @type {(inputs: Plan_Website_Price_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time fee`)
};

/**
* | output |
* | --- |
* | "one-time fee" |
*
* @param {Plan_Website_Price_SuffixInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_price_suffix = /** @type {((inputs?: Plan_Website_Price_SuffixInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_Price_SuffixInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_price_suffix(inputs)
	return en_plan_website_price_suffix(inputs)
});